<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="900px" class="diglog-card" :close-on-click-modal="false" @closed="handleDialogClose">
      <!-- 自定义标题，包含标题文本和状态标签 -->
      <div slot="title" class="dialog-title-wrapper">
        <span class="dialog-title-text">{{ cashOutData.status === 8 ? $t('merchantAccount.confirm_cash_out') : $t('system.withdraw_details') }}</span>
        <el-tag :type="getStatusType(cashOutData.status)" size="small" class="status-tag">
          {{ getStatusText(cashOutData.status) }}
        </el-tag>
      </div>

      <div class="diglog-container">
        <div class="header-line" />

        <el-form ref="confirmForm" :model="formData" label-position="top" style="margin-top: 18px">
          <!-- 第二行：提现金额（可编辑） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('data.withdrawal_amount')" prop="withdraw_amount">
                <div class="edit-item">
                  <span v-if="!isEditWithdrawAmount" class="amount-value">
                    {{ cashOutData.source_currency }} {{ formData.withdraw_amount }}
                  </span>
                  <el-input
                    v-else
                    v-model="formData.withdraw_amount"
                    type="text"
                    size="small"
                    class="simple-input"
                    clearable
                    @input="handleWithdrawAmountInput"
                  />
                  <el-button
                    v-if="canEditAmount && isEditWithdrawAmount"
                    class="edit-cancel-btn"
                    @click="handleEditWithdrawAmount('close')"
                  >
                    Cancel
                  </el-button>
                  <el-button
                    v-if="canEditAmount && isEditWithdrawAmount"
                    class="edit-confirm-btn"
                    @click="handleEditWithdrawAmount"
                  >
                    Confirm
                  </el-button>
                  <el-button
                    v-if="canEditAmount && !isEditWithdrawAmount"
                    class="edit-btn"
                    @click="handleEditWithdrawAmount"
                  >
                    <img src="@/assets/img/cash_out_edit.png" alt="edit" class="edit-icon">
                    <span>Edit</span>
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行：到账金额 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('data.amount_received')">
                <div class="input-show-info amount-value">{{ cashOutData.currency }} {{ displayArrivalAmount }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 其他字段：币种、服务费、汇率 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('data.exchange_rate') }}:</span>
                <span class="info-value">{{ cashOutData.exchange_rate ? '1.00 USD = ' + cashOutData.exchange_rate + " " + cashOutData.source_currency : '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('merchant.service_fee') }}:</span>
                <span class="info-value">{{ cashOutData.currency }} {{ formatAmount(cashOutData.service_fee) }}</span>
              </div>
            </el-col>
          </el-row>

<!--          <el-row v-if="showExchangeRateAndInvoice" :gutter="20">-->
<!--            <el-col :span="12">-->
<!--              <div class="info-row">-->
<!--                <span class="info-label">{{ $t('data.exchange_rate') }}:</span>-->
<!--                <span class="info-value">{{ cashOutData.exchange_rate || '-' }}</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->

          <div class="diglog-container">
            <div style="margin: 10px 0;" class="header-line" />
          </div>

          <!-- 银行信息 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('merchant.account_bank') }}:</span>
                <span class="info-value">{{ cashOutData.bank_name || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('merchant.account_num') }}:</span>
                <span class="info-value">{{ cashOutData.bank_account_num || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('merchant.account_name') }}:</span>
                <span class="info-value">{{ cashOutData.bank_account_name || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-row">
                <span class="info-label">{{ $t('merchantAccount.operator') }}:</span>
                <span class="info-value">{{ cashOutData.operator || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <template v-if="showExchangeRateAndInvoice">
            <div style="margin: 10px 0; border-bottom: 2px solid #D3D7DF;" />

            <!-- 发票图片区域 -->
            <div class="section-title">
              {{ $t('data.invoice_image') }}
            </div>

            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <div>
                    <!-- 已上传的图片列表 -->
                    <div v-if="attachments.length > 0" class="uploaded-images-container">
                      <div v-for="(item, index) in sortedAttachments" :key="index" class="uploaded-image-item">
                        <div v-if="isImg(item.attachment_content)" class="image-wrapper">
                          <el-image
                            style="height:120px; width:120px"
                            :src="item.attachment_content_oss_url"
                            :preview-src-list="allImageUrls"
                            fit="cover"
                          />
                          <div v-if="canDeleteAttachment(item.originalIndex)" class="delete-icon" @click="onClickRemoveBtn(item.originalIndex)">
                            <i class="el-icon-close" />
                          </div>
                        </div>
                        <div v-else class="file-item">
                          <i class="el-icon-document" />
                          <span
                            :class="['file-name']"
                            @click="handleDownloadFile(item)"
                          >
                            {{ item.attachment_name }}
                          </span>
                          <i
                            v-if="canDeleteAttachment(item.originalIndex)"
                            class="el-icon-close file-delete-btn"
                            @click="onClickRemoveBtn(item.originalIndex)"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- 上传按钮 - 根据模式和附件数量显示 -->
                    <MultipleUploadFile
                      v-if="canUploadInvoice"
                      :limit-num="maxAttachments"
                      :list="attachments"
                      file-dir="MERCHANT_WITHDRAW_INVOICE"
                      @templateFileSuccess="templateFileSuccess"
                      v-on="$listeners"
                    />

                    <!-- 提示文案 -->
                    <div v-if="$store.getters.curCountry.country_code === 'MY'" class="invoice-tips">
                      <div class="tip-item">
                        <span class="tip-label">Item Description:</span>
                        <span class="tip-value">merchant settlement</span>
                      </div>
                      <div class="tip-item">
                        <span class="tip-label">To:</span>
                        <span class="tip-value">Micro Bluetech Sdn Bhd</span>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>

      <div class="diglog-container">
        <div style="margin: 10px 0;" class="header-line" />
      </div>
      <div class="diglog-container">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-row">
              <span class="info-label">{{ $t('merchantAccount.create_time') }}:</span>
              <span class="info-value">{{ cashOutData.create_time | formatDate }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-row">
              <span class="info-label">{{ $t('merchantAccount.update_time') }}:</span>
              <span class="info-value">{{ cashOutData.update_time | formatDate }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-row">
              <span class="info-label">{{ $t('merchantAccount.complete_time') }}:</span>
              <span class="info-value">{{ cashOutData.transaction_return_time | formatDate }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div v-if="showFooter" slot="footer" class="dialog-footer">
        <el-button v-if="showConfirmBtn" type="info" :disabled="submiting" :loading="submiting" @click="handleConfirmCashOut">{{ submitBtnText }}</el-button>
        <el-button v-if="showCancelBtn" :type="isPendingPricing ? 'primary' : ''" :plain="isPendingPricing" @click="handleCancelCashOut">{{ cancelBtnText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { withdrawTransactionStatusMap } from '@/utils/maps'
import { fetchMchWithdrawDetail, fetchConfirmPricing, fetchUploadInvoice } from '@/api/settlement/settlement'
import serviceConst from '@/const/serviceConst.json'
import { fetchWithdrawType } from '@/api/system/system'
import { getWithdrawThreshold } from '@/api/merchant-manage/merchant-manage'
import MultipleUploadFile from '@/views/components/Upload/MultipleUploadFile.vue'

export default {
  name: 'Confirm_CashOut_Modal',
  components: {
    MultipleUploadFile
  },
  filters: {
    formatDate(value) {
      if (!value) return '-'
      const date = new Date(value)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      useMockData: false, // mock 数据开关，true 使用 mock 数据，false 调用真实接口
      modalMode: 'confirm', // 模式：'detail' 详情模式，'confirm' 确认模式
      dialogVisible: false,
      submiting: false,
      loading: false,
      withdrawId: null,
      attachments: [], // 存储多个附件
      originalAttachments: [], // 原始附件列表（用于详情模式判断是否允许上传）
      maxAttachments: 6, // 最多6个文件
      formData: {
        withdraw_amount: 0
      },
      isEditWithdrawAmount: false, // 控制提现金额编辑状态
      originalWithdrawAmount: '', // 保存原始提现金额，用于取消时恢复
      displayArrivalAmount: '', // 显示的到账金额（点击确认后才更新）
      exchangeFee: '', // 换汇手续费费
      canEditAmount: false, // 控制是否可以编辑提现金额
      withdrawSettings: {},
      cashOutData: {
        currency: '',
        source_currency: '',
        status: 1,
        arrival_amount: 0,
        service_fee: 0,
        withdraw_amount: 0,
        exchange_rate: '',
        bank_name: '',
        bank_account_num: '',
        bank_account_name: '',
        bank_attribution: '',
        swift: '',
        operator: '',
        create_time: '',
        update_time: '',
        transaction_return_time: '',
        can_upload_invoice: false,
        invoice_mandatory: false,
        remark: ''
      }
    }
  },
  computed: {
    // 获取所有图片URL用于预览
    allImageUrls() {
      return this.attachments
        .filter(item => this.isImg(item.attachment_content))
        .map(item => item.attachment_content_oss_url)
    },
    // 排序后的附件列表：图片在前，文件在后
    sortedAttachments() {
      const images = []
      const files = []

      this.attachments.forEach((item, index) => {
        const sortedItem = { ...item, originalIndex: index }
        if (this.isImg(item.attachment_content)) {
          images.push(sortedItem)
        } else {
          files.push(sortedItem)
        }
      })

      return [...images, ...files]
    },
    // 是否为详情模式
    isDetailMode() {
      return this.modalMode === 'detail'
    },
    // 是否为确认模式
    isConfirmMode() {
      return this.modalMode === 'confirm'
    },
    // 是否为本币提现（source_currency === currency）
    isLocalCurrencyWithdraw() {
      return this.cashOutData.source_currency === this.cashOutData.currency
    },
    // 是否显示汇率和发票（详情模式下本币提现不显示）
    showExchangeRateAndInvoice() {
      if (this.originalAttachments.length === 0 && !this.cashOutData.can_upload_invoice) {
        return false
      }
      if (this.isDetailMode && this.isLocalCurrencyWithdraw) {
        return false
      }
      if (this.cashOutData.status === 7) {
        return false
      }
      return true
    },
    // 提交按钮文案
    submitBtnText() {
      // 状态 2 或 4 时，如果原始附件为空，显示"提交"（用于补传发票）
      if ([2, 4].includes(this.cashOutData.status) && this.cashOutData.can_upload_invoice) {
        return this.$t('components.submit')
      }
      return this.$t('merchantAccount.confirm_cash_out')
    },
    // 取消按钮文案
    cancelBtnText() {
      // 状态 2 或 4 时，如果原始附件为空，显示"取消"（用于补传发票）
      if ([2, 4].includes(this.cashOutData.status) && this.cashOutData.can_upload_invoice) {
        return this.$t('components.cancel')
      }
      // 待定价状态显示"取消提现"
      if (this.cashOutData.status === 7) {
        return this.$t('merchantAccount.cancel_cash_out')
      }
      return this.$t('merchantAccount.cancel_cash_out')
    },
    // 是否显示底部按钮区域
    showFooter() {
      // 状态 2 ,4时，如果原始附件为空，允许显示底部按钮（用于补传发票）
      if ([2, 4].includes(this.cashOutData.status) && this.cashOutData.can_upload_invoice) {
        return true
      }
      if ([7, 8].includes(this.cashOutData.status)) {
        return true
      }
      return false
    },
    // 是否显示确认按钮（待定价状态不显示）
    showConfirmBtn() {
      return this.cashOutData.status !== 7
    },
    // 是否显示取消按钮（俄罗斯不显示）
    showCancelBtn() {
      return this.$store.getters.curCountry.country_code !== 'RU'
    },
    // 是否为印尼国家（印尼只允许输入整数金额）
    isIndonesia() {
      return this.$store.getters.curCountry.country_code === 'ID'
    },
    // 是否为整数金额国家（印尼/越南只允许输入整数金额）
    isIntegerAmountCountry() {
      return ['ID', 'VN'].includes(this.$store.getters.curCountry.country_code)
    },
    // 是否为俄罗斯国家
    isRussia() {
      return this.$store.getters.curCountry.country_code === 'RU'
    },
    // 是否需要校验最低提现限额（只有印尼和俄罗斯需要）
    needCheckWithdrawThreshold() {
      return this.isIndonesia || this.isRussia
    },
    // 是否为待定价状态
    isPendingPricing() {
      return this.cashOutData.status === 7
    },
    // 是否允许上传发票（详情模式下只有原始附件为空时才允许上传）
    canUploadInvoice() {
      // 接口返回不允许上传发票
      if (!this.cashOutData.can_upload_invoice) {
        return false
      }
      // 状态 2 或 4 时，如果原始附件为空，允许上传发票
      if ([2, 4].includes(this.cashOutData.status) && this.originalAttachments.length === 0) {
        return this.attachments.length < this.maxAttachments
      }
      // 状态 3（失败）不允许上传
      if (this.cashOutData.status === 3) {
        return false
      }
      // 其他情况：正常判断
      return this.attachments.length < this.maxAttachments
    },
    // 是否允许删除附件
    canDeleteAttachment() {
      return (index) => {
        // 如果是从接口获取的原始附件
        if (index < this.originalAttachments.length) {
          // 只有在待确认状态（status === 8）时才能删除
          return this.cashOutData.status === 8
        }
        // 如果是手动上传的附件，任何时候都可以删除
        return true
      }
    }
  },
  methods: {
    // 获取提现设置（根据国家调用不同接口）
    getWithdrawSettings() {
      // 只有印尼和俄罗斯需要获取提现限额设置
      if (!this.needCheckWithdrawThreshold) {
        return
      }
      if (this.isIndonesia) {
        // 印尼使用 fetchWithdrawType 接口
        fetchWithdrawType().then(res => {
          const { data } = res || {}
          this.withdrawSettings = data
        })
      } else if (this.isRussia) {
        // 俄罗斯使用 getWithdrawThreshold 接口
        getWithdrawThreshold().then(res => {
          const { data } = res || {}
          this.withdrawSettings = data
        })
      }
    },
    // 格式化金额为两位小数
    formatAmount(value) {
      return Number(this.$options.filters['toDivide100'](value)).toFixed(2)
    },
    // 判断是否是图片
    isImg(value) {
      if (!value) return false
      // 去除查询参数后再判断扩展名
      // const urlWithoutQuery = value.split('?')[0]
      // return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(urlWithoutQuery)
      const decoded = decodeURIComponent(value)
      // 再去掉查询参数
      const urlWithoutQuery = decoded.split('?')[0]
      return /\.(gif|jpg|jpeg|png)$/i.test(urlWithoutQuery)
    },
    // 改变弹框状态
    // rowData: 列表行数据
    changModalStatus(value, rowData = null) {
      this.dialogVisible = value
      if (value && rowData) {
        // 从行数据中获取 withdrawId
        this.withdrawId = rowData.withdraw_id || rowData.id
        // 根据状态判断模式：状态8为确认模式，其他为详情模式
        const isConfirmMode = rowData.disburse_status === 8
        this.modalMode = isConfirmMode ? 'confirm' : 'detail'
        this.canEditAmount = isConfirmMode
        // 用行数据初始化基础信息，避免等待接口返回
        this.initFromRowData(rowData)
        // 获取详情
        this.getWithdrawDetail(this.withdrawId)
        // 获取提现设置（只有印尼和俄罗斯需要）
        this.getWithdrawSettings()
      }
    },
    // 从列表行数据初始化基础信息
    initFromRowData(row) {
      this.cashOutData.status = row.disburse_status || 1
      this.cashOutData.currency = row.currency || ''
      this.cashOutData.source_currency = row.source_currency || ''
      this.cashOutData.can_upload_invoice = row.can_upload_invoice !== undefined ? row.can_upload_invoice : false
      this.cashOutData.invoice_mandatory = row.invoice_mandatory !== undefined ? row.invoice_mandatory : false
    },
    // 获取提现详情
    getWithdrawDetail(withdrawId) {
      this.loading = true

      if (this.useMockData) {
        // mock 数据 - 本币提现场景
        const mockData = {
          id: withdrawId,
          merchant_id: 10001,
          merchant_name: 'Test Merchant',
          merchant_no: 'MCH202312001',
          withdraw_amount: 1000000, // 10000.00
          arrive_amount: 1000000, // 10000.00
          source_currency: 'USD',
          currency: 'PHP', // 与 source_currency 相同，触发本币提现
          exchange_rate: 35, // 本币提现汇率为 1
          fee_split: 20000, // 200.00
          disburse_status: 4, // 待处理
          bank: 'Bank of America',
          bank_account: '****1234',
          bank_account_name: 'Test Account',
          bank_attribution: 'United States',
          swift: 'BOFAUS3N',
          withdraw_type: 1,
          operation_type: 1,
          invoice_files: [],
          pricing_files: [],
          remark: '',
          create_time: '2024-12-26 10:30:00',
          pricing_time: '',
          confirm_time: '',
          update_time: '',
          transaction_return_time: '',
          can_upload_invoice: false,
          invoice_mandatory: true
        }

        // 模拟接口延迟
        setTimeout(() => {
          this.handleWithdrawDetailData(mockData)
          this.loading = false
        }, 500)
      } else {
        // 调用真实接口
        fetchMchWithdrawDetail({ withdraw_id: withdrawId }).then(res => {
          if (res.code === serviceConst.resCode.succ && res.data) {
            this.handleWithdrawDetailData(res.data)
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 处理提现详情数据
    handleWithdrawDetailData(data) {
      this.cashOutData = {
        currency: data.currency || '',
        source_currency: data.source_currency || '',
        status: data.disburse_status || 1,
        arrival_amount: data.arrive_amount || 0,
        service_fee: data.fee_split || 0,
        withdraw_amount: data.withdraw_amount || 0,
        exchange_rate: data.exchange_rate || '',
        bank_name: data.bank || '',
        bank_account_num: data.bank_account || '',
        bank_account_name: data.bank_account_name || '',
        bank_attribution: data.bank_attribution || '',
        swift: data.swift || '',
        operator: data.operate_username || '',
        create_time: data.create_time || '',
        update_time: data.update_time || '',
        transaction_return_time: data.transaction_return_time || '',
        can_upload_invoice: data.can_upload_invoice,
        invoice_mandatory: data.invoice_mandatory,
        remark: data.remark || ''
      }
      // 更新附件列表
      if (data.invoice_files && data.invoice_files.length > 0) {
        this.attachments = data.invoice_files.map(file => ({
          attachment_name: file.file_name || '',
          attachment_content: file.file_url || file.file_path || '',
          attachment_content_oss_url: file.file_url || file.file_path || ''
        }))
        // 保存原始附件列表
        this.originalAttachments = [...this.attachments]
        // 暂时兼容 pricing_files 字段
      } else if (data.pricing_files && data.pricing_files.length > 0) {
        this.attachments = data.pricing_files.map(file => ({
          attachment_name: file.file_name || '',
          attachment_content: file.file_url || file.file_path || '',
          attachment_content_oss_url: file.file_url || file.file_path || ''
        }))
        // 保存原始附件列表
        this.originalAttachments = [...this.attachments]
      } else {
        this.attachments = []
        this.originalAttachments = []
      }
      // 更新提现金额（印尼/越南国家不带小数点）
      const withdrawAmountNum = Number(this.$options.filters['toDivide100'](data.withdraw_amount))
      this.formData.withdraw_amount = this.isIntegerAmountCountry ? String(Math.floor(withdrawAmountNum)) : withdrawAmountNum.toFixed(2)
      this.originalWithdrawAmount = this.formData.withdraw_amount
      // 初始化到账金额
      this.displayArrivalAmount = Number(this.$options.filters['toDivide100'](data.arrive_amount)).toFixed(2)
      this.exchangeFee = Number(this.$options.filters['toDivide100'](data.fee_split)).toFixed(2)
    },
    // 获取状态类型和文本
    getStatusType(status) {
      const statusObj = withdrawTransactionStatusMap(status)
      return statusObj.type || 'info'
    },
    // 获取状态文本
    getStatusText(status) {
      const statusObj = withdrawTransactionStatusMap(status)
      return statusObj.label || status
    },
    getExchangeExampleAmount(exchangeRate) {
      const rate = Number(exchangeRate)
      if (!isNaN(rate) && rate > 0) {
        return rate.toFixed(2)
      }
      return null
    },
    // 处理提现金额输入（印尼/越南只允许整数）
    handleWithdrawAmountInput(value) {
      if (this.isIntegerAmountCountry) {
        // 印尼/越南国家只允许输入整数，过滤非数字字符
        this.formData.withdraw_amount = value.replace(/[^\d]/g, '')
      }
    },
    // 处理提现金额编辑
    handleEditWithdrawAmount(action) {
      if (action === 'close') {
        // 取消编辑，恢复原始值
        this.formData.withdraw_amount = this.originalWithdrawAmount
        this.isEditWithdrawAmount = false
      } else {
        if (this.isEditWithdrawAmount) {
          // 确认编辑
          // 验证金额
          const amount = Number(this.formData.withdraw_amount)
          if (!this.formData.withdraw_amount || amount <= 0 || isNaN(amount)) {
            this.$message.warning('Please enter valid withdraw amount!')
            return
          }
          // 验证最低提现金额（只有印尼和俄罗斯需要校验）
          if (this.needCheckWithdrawThreshold && this.withdrawSettings.withdraw_threshold) {
            const minAmount = Number(this.withdrawSettings.withdraw_threshold) / 100
            if (minAmount > 0 && amount < minAmount) {
              this.$message.warning('Cash Out Amount should be greater than or equal to ' + this.$options.filters['toDivideWithDot'](this.withdrawSettings.withdraw_threshold))
              return
            }
          }
          // 印尼/越南国家只允许整数
          if (this.isIntegerAmountCountry) {
            if (!/^(0|[1-9]\d*)$/.test(this.formData.withdraw_amount)) {
              this.$message.warning(this.isIndonesia ? 'Indonesia only supports integer amounts' : 'Only integer amounts are supported')
              return
            }
            // 印尼/越南金额保持整数，不带小数点
            this.formData.withdraw_amount = String(Math.floor(amount))
          } else {
            if (!/^(0|[1-9]\d*)(.\d{1,2})?$/.test(this.formData.withdraw_amount)) {
              this.$message.warning('Please enter two decimal places')
              return
            }
            // 格式化为两位小数并保存
            this.formData.withdraw_amount = amount.toFixed(2)
          }
          this.originalWithdrawAmount = this.formData.withdraw_amount
          // 计算并更新到账金额（提现金额 / 汇率 - fee_split）
          const exchangeRate = Number(this.cashOutData.exchange_rate)
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            // 先计算汇率转换后的金额，四舍五入保留两位小数
            let arrivalAmount = Math.round((amount / exchangeRate) * 100) / 100
            // 如果 fee_split 不为空，需要减去手续费
            const feeSplit = Number(this.exchangeFee)
            if (!isNaN(feeSplit) && feeSplit > 0) {
              // 减去手续费后再次四舍五入保留两位小数
              arrivalAmount = Math.round((arrivalAmount - feeSplit) * 100) / 100
            }
            // 检查到账金额是否大于0
            if (arrivalAmount <= 0) {
              this.$message.warning(this.$t('tips.invalid_withdrawal_amount_arrival'))
              return
            }
            this.displayArrivalAmount = arrivalAmount.toFixed(2)
          }
          this.isEditWithdrawAmount = false
          this.$message.success('Withdraw amount updated!')
        } else {
          // 进入编辑模式
          this.isEditWithdrawAmount = true
        }
      }
    },
    // 删除指定图片
    onClickRemoveBtn(index) {
      this.attachments.splice(index, 1)
      this.$forceUpdate()
    },
    // 下载文件
    handleDownloadFile(item) {
      if (!item.attachment_content_oss_url) {
        this.$message.warning('File URL not found')
        return
      }
      // 创建一个隐藏的 a 标签来触发下载
      const link = document.createElement('a')
      link.href = item.attachment_content_oss_url
      link.download = item.attachment_name || 'download'
      link.target = '_blank'
      // 添加到页面并触发点击
      document.body.appendChild(link)
      link.click()
      // 移除 a 标签
      document.body.removeChild(link)
    },
    // 上传成功回调
    templateFileSuccess(data = {}) {
      if (this.attachments.length >= this.maxAttachments) {
        this.$message.warning(`Maximum ${this.maxAttachments} files allowed!`)
        return
      }

      const attachment = {
        attachment_name: data.fileName,
        attachment_content: data.relativePath,
        attachment_content_oss_url: data.absolutePath
      }
      this.attachments.push(attachment)
      this.$forceUpdate()
    },
    // 确认提现/提交发票
    handleConfirmCashOut() {
      // 获取发票文件列表（包含文件名和URL）
      const invoiceFileUrls = this.attachments.map(item => ({
        invoice_file_name: item.attachment_name,
        invoice_file_url: item.attachment_content
      }))

      // 状态 2 或 4 时，如果原始附件为空，允许补传发票
      const isSupplementInvoice = [2, 4].includes(this.cashOutData.status) && this.originalAttachments.length === 0

      if (isSupplementInvoice) {
        // 补传发票模式：上传发票
        if (this.cashOutData.invoice_mandatory && this.attachments.length === 0) {
          this.$message.warning('Please upload at least one invoice image!')
          return
        }

        this.$confirm('Are you sure to submit the invoice?', 'Confirm', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.submiting = true
          const params = {
            withdraw_id: this.withdrawId,
            invoice_files: invoiceFileUrls
          }

          if (this.useMockData) {
            // mock 模式
            console.log('Upload Invoice params:', params)
            setTimeout(() => {
              this.submiting = false
              this.changModalStatus(false)
              this.$emit('confirm-success')
              this.$message.success('Invoice uploaded successfully!')
            }, 1000)
          } else {
            // 调用真实接口
            fetchUploadInvoice(params).then(res => {
              if (res.code === serviceConst.resCode.succ) {
                this.changModalStatus(false)
                this.$emit('confirm-success')
                this.$message.success('Invoice uploaded successfully!')
              } else {
                this.$message.error(res.msg || 'Upload failed!')
              }
            }).finally(() => {
              this.submiting = false
            })
          }
        }).catch(() => {})
      } else {
        // 确认模式：确认提现
        if (this.cashOutData.invoice_mandatory && this.attachments.length === 0) {
          this.$message.warning('Please upload at least one invoice image!')
          return
        }

        if (!this.formData.withdraw_amount || Number(this.formData.withdraw_amount) <= 0) {
          this.$message.warning('Please enter valid withdraw amount!')
          return
        }

        this.$confirm(this.$t('data.confirm_cash_out_message'), this.$t('data.confirm_cash_out_title'), {
          confirmButtonText: this.$t('data.confirm_cash_out_btn'),
          cancelButtonText: this.$t('data.cancel_cash_out_btn'),
          type: 'warning'
        }).then(() => {
          this.submiting = true
          // 使用提现金额作为 withdraw_amount 入参
          const params = {
            withdraw_id: this.withdrawId,
            withdraw_amount: this.$commonFn.mathMultiply(Number(this.formData.withdraw_amount), 100),
            invoice_files: invoiceFileUrls
          }

          if (this.useMockData) {
            // mock 模式
            console.log('Confirm Pricing params:', params)
            setTimeout(() => {
              this.submiting = false
              this.changModalStatus(false)
              this.$emit('confirm-success')
              this.$message.success('Cash out confirmed successfully!')
            }, 1000)
          } else {
            // 调用真实接口
            fetchConfirmPricing(params).then(res => {
              if (res.code === serviceConst.resCode.succ) {
                this.changModalStatus(false)
                this.$emit('confirm-success')
                this.$message.success('Cash out confirmed successfully!')
              } else {
                this.$message.error(res.msg || 'Confirm failed!')
              }
            }).finally(() => {
              this.submiting = false
            })
          }
        }).catch(() => {})
      }
    },
    // 取消提现
    handleCancelCashOut() {
      if (this.isConfirmMode || this.cashOutData.status === 7) {
        // 确认模式或待定价状态：弹出取消提现弹窗
        this.dialogVisible = false
        this.$emit('open-cancel-modal', this.withdrawId)
      } else {
        // 详情模式：直接关闭
        this.dialogVisible = false
        this.$emit('cancel-cash-out')
      }
    },
    // 关闭弹窗
    handleDialogClose() {
      this.attachments = []
      this.originalAttachments = []
      // this.modalMode = 'confirm'
      this.formData.withdraw_amount = ''
      this.isEditWithdrawAmount = false
      this.originalWithdrawAmount = ''
      this.displayArrivalAmount = ''
      this.withdrawId = null
      this.cashOutData = {
        currency: '',
        status: 1,
        arrival_amount: 0,
        service_fee: 0,
        withdraw_amount: 0,
        exchange_rate: '',
        bank_name: '',
        bank_account_num: '',
        bank_account_name: '',
        operator: '',
        create_time: '',
        update_time: '',
        transaction_return_time: ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 自定义 dialog 标题样式
.dialog-title-wrapper {
  display: flex;
  align-items: center;

  .dialog-title-text {
    color: #1B4AEF;
    font-family: "Inter Tight", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-right: 12px;
  }

  .status-tag {
    margin-left: 8px;
    padding: 0 18px;
  }
}

.dialog-footer{
  margin-top: -16px;
  text-align: center;
}

// 去除展示字段的边框和背景
.input-show-info {
  border: none;
  background: transparent;
  padding: 0;
  min-height: 32px;
  line-height: 32px;
  color: #303133;
  font-size: 14px;
}

// 提现金额和到账金额的数据样式
.amount-value {
  color: #1B4AEF;
  font-family: "Inter Tight";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

// 简单输入框样式
.simple-input {
  width: 200px;

  ::v-deep .el-input__inner {
    border: none;
    border-bottom: 1px solid #DCDFE6;
    border-radius: 0;
    background: transparent;
    color: #1B4AEF;
    font-family: "Inter Tight";
    font-size: 24px;
    font-weight: 600;
    height: auto;
    line-height: normal;
    padding: 4px 0;
  }
}

// 编辑取消按钮样式
.edit-cancel-btn {
  display: flex;
  width: 100px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  background: #FFF;
  color: rgba(0, 0, 0, 0.50);
  text-align: center;
  font-family: "Inter Tight";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

// 编辑确认按钮样式
.edit-confirm-btn {
  display: flex;
  width: 100px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 2px;
  border: none;
  background: #1B4AEF;
  color: #FFF;
  text-align: center;
  font-family: "Inter Tight";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

// 编辑项样式
.edit-item {
  display: flex;
  align-items: center;
  gap: 12px;

  .amount-value {
    min-width: auto;
    margin-right: 4px;
  }

  .el-button {
    margin-left: 0;
  }
}

// 编辑按钮样式
.edit-btn {
  width: 100px;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  background: #FFF;

  ::v-deep > span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }

  .edit-icon {
    width: 15px;
    height: 15px;
    vertical-align: middle;
  }

  span {
    color: rgba(0, 0, 0, 0.50);
    text-align: center;
    font-family: "Inter Tight";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

// 信息行样式 - 文案和数据在同一行
.info-row {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin-bottom: 12px;

  .info-label {
    color: #1D3A71;
    text-align: center;
    font-family: "Inter Tight";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .info-value {
    color: rgba(24, 24, 24, 0.50);
    font-family: "Inter Tight";
    margin-left: 10px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    flex:1;
  }
}

// 上传的图片容器
.uploaded-images-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.uploaded-image-item {
  min-width: 0;

  // 图片项不占满整行，可以横向排列
  &:has(.image-wrapper) {
    width: auto;
  }

  // 文件项占满整行
  &:has(.file-item) {
    width: 100%;
  }

  .image-wrapper {
    position: relative;
    display: inline-block;
    width: 120px;
    height: 120px;
    border-radius: 4px;
    overflow: hidden;

    &:hover .delete-icon {
      opacity: 1;
    }

    .delete-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s;
      z-index: 10;

      &:hover {
        background-color: rgba(255, 0, 0, 0.8);
      }

      i {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .file-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 8px;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;

    .el-icon-document {
      color: #909399;
      font-size: 16px;
      flex-shrink: 0;
    }

    .file-name {
      flex: 1;
      min-width: 0;
      max-width: 100%;
      display: block;
      color: #606266;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      text-decoration: underline;

      &:hover:not(.file-disabled) {
        color: #409EFF;
      }

      &.file-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
        text-decoration: none;
        opacity: 0.6;
      }
    }

    .file-delete-btn {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #f56c6c;
      }
    }
  }
}

// 发票提示文案
.invoice-tips {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border-left: 4px solid #409EFF;

  .tip-item {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }

    .tip-label {
      font-weight: 500;
      color: #606266;
      margin-right: 8px;
    }

    .tip-value {
      color: #303133;
    }
  }
}
</style>
